<template lang="html">
  <div class="main" v-loading="loading" element-loading-background="rgba(255, 255, 255, 0)">
    <i class="material-icons none" v-if="pkgs.length === 0 && !loading">
      cloud_upload
    </i>
    <div class="main-cell">
      <comp-pkg
        v-for="(pkg, index) in pkgs"
        :key = "pkg.id"
        :type="type"
        :state="state"
        :t_state="pkg.t_state"
        :id="pkg.id"
        :name='pkg.name'
        :title="pkg.title"
        :time="pkg.time"
        :size="pkg.size"
        :notes="pkg.notes"
        :weight="pkg.weight"
        :percent="pkg.percent"
        :fileNum="pkg.fileNum"
        :index="index"
        :downloadTimes="pkg.downloadTimes"
        @deleteSuccess="deletea(index)"
        @updateSuccess="updatea(index)"
        @removeActive="removeAllActive(index)"
        :timeWord="pkg.timeWord"
        :deletion="pkg.deletion"
        :imgUrl="pkg.imgUrl"
        :expire="pkg.expire"
        :isActive="pkg.isActive"
        :userIdList="pkg.userIdList"
        :userRole="userRole"
        :recordNum="pkg.recordNum"
      >
      </comp-pkg>
    </div>
    <div id="loadMoreElement"></div>
    <span class="" v-show="loadMore">
      {{message.Sl103}}
    </span>
    <span class="more" v-show="loadEnd && pkgs.length >= 20">
      {{message.Sl104}}
    </span>
  </div>
</template>

<script>
import CompPkg from '@/components/box/pkg.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    CompPkg
  },
  created () {
    this.$store.dispatch('addProject', localStorage.getItem('projectId'))
  },
  computed: {
    ...mapGetters({
      scroll: 'scroll',
      el: 'el',
      space: 'space',
      transfer: 'transfer',
      size: 'size'
    }),
    // style: function () {
    //   var data = {
    //     minHeight: this.size.height - 105 + 'px'
    //   }
    //   return data
    // }
  },
  watch: {
    'transfer.aliveList': function () {
      if (this.transfer.aliveList.error !== 0) {
        return
      }
      if (
        this.transfer.aliveList.tasks.length !== 0
      ) {
        var data = this.transfer.aliveList.tasks
        for (var i = 0; i < data.length; i++) {
          if (data[i].taskType === 0 && data[i].projectId === this.space.id) {
            var num = data[i].transfer.percent
            if (num <= 100) {
              var percent = num
            } else {
              percent = 100
            }
            this.maps.set(data[i].packageId, percent)
            var array = Array.from(this.maps.keys())
            var index = array.indexOf(data[i].packageId)
            if (index !== -1) {
              this.pkgs[index].percent = percent
            }
          }
        }
      }
      if (
        this.transfer.aliveList.taskEvents.length !== 0
      ) {
        for (var y = 0; y < this.transfer.aliveList.taskEvents.length; y++) {
          data = this.transfer.aliveList.taskEvents
          if (data[y].event === 9) {
            this.$app.taskMore('upload', data[y].taskId, response => {
              if (response.taskType === 0) {
                var num = response.transfer.percent
                if (num <= 100) {
                  var percent = num
                } else {
                  percent = 100
                }
                this.maps.set(response.packageId, percent)
                var array = Array.from(this.maps.keys())
                var index = array.indexOf(response.packageId)
                if (index !== -1) {
                  this.pkgs[index].percent = percent
                }
              }
            })
          }
        }
      }
    },
    scroll: function () {
      if (this.loading) {
        return
      }
      var clientHeight = document.documentElement.clientHeight
      var scrollTop = this.getScrollTop()
      // if (this._global.config.browser === 'qt') {
      //   scrollTop = document.body.scrollTop
      // }
      var scrollHeight = document.documentElement.scrollHeight
      if (clientHeight + scrollTop >= scrollHeight) {
        this.moreContent()
      }
    },
    'el.sentFile': function (val) {
      if (val) {
        this.num = 1
        this.pkgs = []
        this.maps = new Map()
        this.packagesList()
      }
    },
    space: function () {
      this.num = 1
      this.pkgs = []
      this.maps = new Map()
      this.packagesList()
      this.setRole()
    }
  },
  data () {
    var maps = new Map()
    return {
      message: {
        Sl103: this.$lang.ui.system.l103,
        Sl104: this.$lang.ui.system.l104
      },
      loading: false,
      num: 1,
      state: 'upload',
      type: 'sender',
      loadMore: false,
      pkgs: [],
      maps: maps,
      loadEnd: false,
      position: '',
      maxNum: '',
      userRole: 0,
      timeDate: {
        today: {
          active: false,
          value: this.$lang.ui.system.date.l0
        },
        yesterday: {
          active: false,
          value: this.$lang.ui.system.date.l1
        },
        week: {
          active: false,
          value: this.$lang.ui.system.date.l2
        },
        month: {
          active: false,
          value: this.$lang.ui.system.date.l3
        },
        monthList: [
          [false, this.$lang.ui.system.date.l01],
          [false, this.$lang.ui.system.date.l02],
          [false, this.$lang.ui.system.date.l03],
          [false, this.$lang.ui.system.date.l04],
          [false, this.$lang.ui.system.date.l05],
          [false, this.$lang.ui.system.date.l06],
          [false, this.$lang.ui.system.date.l07],
          [false, this.$lang.ui.system.date.l08],
          [false, this.$lang.ui.system.date.l09],
          [false, this.$lang.ui.system.date.l10],
          [false, this.$lang.ui.system.date.l11],
          [false, this.$lang.ui.system.date.l12]
        ]
      }
    }
  },
  mounted () {
    this.$store.dispatch('showBox', 'outbox')
    // Set to true so that after the first package list fetching, auto fill package list until browser height is reached
    this.packagesList(true)
    this.setRole()
    window.removeEventListener('scroll', this._global.moreContent)
    window.addEventListener('scroll', this._global.moreContent)
  },
  methods: {
    getScrollTop () {
      return window.scrollY || window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
    },
    setRole () {
      this.$api.getUserRole(this.space.id, response => {
        this.$store.dispatch('addRole', response.permission.role)
        this.userRole = response.permission.operation
      })
    },
    removeAllActive (index) {
      for (var i = 0; i < this.pkgs.length; i++) {
        if (i !== index) {
          this.pkgs[i].isActive = ''
        }
      }
      if (this.pkgs[index].isActive === '') {
        this.pkgs[index].isActive = 'active'
      } else {
        this.pkgs[index].isActive = ''
      }
    },
    deletea (index) {
      if (this.pkgs[index].timeWord !== '') {
        var a = index + 1
        if (a !== this.pkgs.length) {
          if (this.pkgs[a].timeWord !== undefined && this.pkgs[a].timeWord === '') {
            this.pkgs[a].timeWord = this.pkgs[index].timeWord
          }
        }
      }
      this.maps.delete(this.pkgs[index].id)
      this.pkgs.splice(index, 1)
      // this.pkgs[index].deletion = {
      //   id: localStorage.getItem('userId'),
      //   is: true,
      //   name: '',
      //   type: 'self',
      //   time: ''
      // }
    },
    packagesList (autoFetchNext) {
      if (!this.space.id) {
        return
      }
      this.loading = true
      this.timeDate.today.active = false
      this.timeDate.yesterday.active = false
      this.timeDate.week.active = false
      this.timeDate.month.active = false
      this.$store.dispatch('sentFile', false)
      for (var z = 0; z < this.timeDate.monthList.length; z++) {
        this.timeDate.monthList[z][0] = false
      }
      this.$http.get('/cydex/api/v1/packages', { params: {
        'project_id': this.space.id,
        't': 's',
        is_del: 0,
        'with_receivers': 1,
        'with_sender': 1,
        'page_num': this.num,
        'page_size': 20
      } })
        .then(response => {
          this.loading = false
          this.loadMore = false
          this.loadEnd = false
          this.maxNum = Math.ceil(response.data.total_num / 20)
          for (var i = 0; i < response.data.packages.length; i++) {
            if (response.data.packages[i].expiration) {
              if (response.data.packages[i].expiration.expires === 0) {
                var expire = {
                  time: '-',
                  distance: ''
                }
              } else {
                expire = {
                  time: this._global.timeSwitch(response.data.packages[i].expiration.expire_at),
                  distance: this._global.dayAfterSwitch(response.data.packages[i].expiration.expire_at, 0)
                }
              }
            }
            if (response.data.packages[i].job_create_at) {
              var createTime = response.data.packages[i].job_create_at
            } else {
              createTime = response.data.packages[i].create_at
            }
            var t = this._global.timeMoreSwitch(createTime)
            var n = this._global.timeMoreSwitch(new Date() / 1000)
            if (t.year === n.year && t.month === n.month && t.date === n.date) {
              if (this.timeDate.today.active) {
                var timeWord = ''
              } else {
                timeWord = this.timeDate.today.value
                this.timeDate.today.active = true
              }
            } else {
              if (t.year === n.year && t.month === n.month && n.date - t.date === 1) {
                if (this.timeDate.yesterday.active) {
                  timeWord = ''
                } else {
                  timeWord = this.timeDate.yesterday.value
                  this.timeDate.yesterday.active = true
                }
              } else {
                if (t.year === n.year && t.month === n.month && n.day === t.day) {
                  if (this.timeDate.week.active) {
                    timeWord = ''
                  } else {
                    timeWord = this.timeDate.week.value
                    this.timeDate.week.active = true
                  }
                } else {
                  if (t.year === n.year && t.month === n.month) {
                    if (this.timeDate.month.active) {
                      timeWord = ''
                    } else {
                      timeWord = this.timeDate.month.value
                      this.timeDate.month.active = true
                    }
                  } else {
                    if (this.timeDate.monthList[t.month - 1][0]) {
                      timeWord = ''
                    } else {
                      timeWord = this.timeDate.monthList[t.month - 1][1]
                      this.timeDate.monthList[t.month - 1][0] = true
                    }
                  }
                }
              }
            }
            var size = this._global.trafficSwitch(response.data.packages[i].size)
            var num = response.data.packages[i].files_num_file || response.data.packages[i].files_num
            var recordNum = (
              response.data.packages[i].files_num - response.data.packages[i].files_num_dir_blank
            ) || response.data.packages[i].files_num
            if (response.data.packages[i].notes !== '') {
              var notes = response.data.packages[i].notes
            } else {
              notes = ''
            }
            if (response.data.packages[i].is_read) {
              var weight = 500
            } else {
              weight = 600
            }
            var downloadTimes = 0
            var imgUrl = ''
            if (response.data.packages[i].receivers !== null) {
              imgUrl = response.data.packages[i].receivers[0].user.pic_url
              var userIdList = []
              for (var x = 0; x < response.data.packages[i].receivers.length; x++) {
                userIdList.push({
                  id: response.data.packages[i].receivers[x].user.id,
                  name: response.data.packages[i].receivers[x].user.name
                })
                downloadTimes = downloadTimes + response.data.packages[i].receivers[x].finished_times
                if (x === 0) {
                  var name = response.data.packages[i].receivers[x].user.name
                } else {
                  name = name + ',' + response.data.packages[i].receivers[x].user.name
                }
                if (response.data.packages[i].receivers.length > 1) {
                  var nameNum = '(' + response.data.packages[i].receivers.length + ')'
                } else {
                  nameNum = ''
                }
              }
            } else {
              name = '-'
              nameNum = ''
            }
            var percent = parseInt(response.data.packages[i].sender.finished_size / response.data.packages[i].size * 100)
            this.maps.set(response.data.packages[i].id, percent)
            this.pkgs.push({
              id: response.data.packages[i].id,
              name: name,
              userIdList: userIdList,
              nameNum: nameNum,
              title: response.data.packages[i].title,
              size: size,
              fileNum: num,
              time: this._global.timeSwitch(createTime),
              notes: notes,
              weight: weight,
              percent: percent,
              timeWord: timeWord,
              downloadTimes: downloadTimes,
              expire: expire,
              imgUrl: imgUrl,
              isActive: '',
              t_state: response.data.packages[i].sender.state,
              recordNum: recordNum,
            })
          }
          // if browser window height is not reached, auto fetch next records
          if (autoFetchNext) {
            // wait for package list to render so that we know the height
            this.$nextTick(this.autoMoreContent)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    updatea (index) {
      this.$http.get('/cydex/api/v1/packages/' + this.pkgs[index].id, {
        params: {
          op: 'upload',
          with_receivers: 1
        }
      })
        .then(response => {
          var name = '-'
          var nameNum = ''
          var imgUrl = response.data.receivers[0].user.pic_url
          var userIdList = []
          if (response.data.receivers.length > 1) {
            nameNum = '(' + response.data.receivers.length + ')'
          }
          for (var i = 0; i < response.data.receivers.length; i++) {
            userIdList.push({
              id: response.data.receivers[i].user.id,
              name: response.data.receivers[i].user.name
            })
            if (i === 0) {
              name = response.data.receivers[i].user.name
            } else {
              name = name + ',' + response.data.receivers[i].user.name
            }
          }
          this.pkgs[index].name = name
          this.pkgs[index].nameNum = nameNum
          this.pkgs[index].imgUrl = imgUrl
          this.pkgs[index].userIdList = userIdList
        })
    },
    moreContent (autoFetchNext) {
      this.num = this.num + 1
      if (this.num <= this.maxNum) {
        this.loadEnd = false
        this.loadMore = true
        this.packagesList(autoFetchNext)
      } else {
        this.loadEnd = true
      }
    },
    autoMoreContent () {
      let contentHeight = document.getElementById('loadMoreElement').getBoundingClientRect().y
      if (this.num <= this.maxNum && contentHeight < document.documentElement.clientHeight) {
        this.moreContent(true)
      }
    }
  }
}
</script>

<style scoped lang="css">
.main {
  position: relative;
  padding: 5px;
  min-height: calc(100% - 45px);
}
.main-cell {
  min-width: 570px;
}
.more {
  display: block;
  width: 100%;
  padding: 10px;
  font-style: italic;
  color: #9e9e9e;
  text-align: center;
}
.none {
  position: absolute;
  top: 48%;
  left: 50%;
  margin-top: -83px;
  margin-left: -82px;
  color: rgba(148, 170, 178, 0.4);
  font-size: 165px;
}
</style>
